import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Select,
  Button,
  DateRangePicker,
  LoadingComponent,
  Modal,
  GroupedTable2,
  TabComponent2,
  DownloadButton,
  MultiSelect,
} from "../../../components/core";
import { useQuery, useLazyQuery } from "@apollo/client";
import {
  LOCKER_INFO_QUERY,
  NEWEST_LOCKER_NAME_QUERY,
  QUERY_LOCKER_NAME,
  QUERY_LOCKER_TYPE,
} from "../../../features/stay-time-in-locker/stay-time-query/stay-time-graphql";
import {
  QUERYlockerOccupancyAvgOccupancyRate,
  QUERYlockerOccupancyReportSummary,
  QUERYlockerOccupancyTable1,
  QUERYlockerOccupancyTable2,
} from "../../../features/locker-occupancy/locker-occupancy";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Label,
  CartesianGrid,
} from "recharts";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { Accordion, AccordionTab } from "primereact/accordion";
import ScrollButton from "../../../components/core/scroll-to-top";
import {
  formatDate,
  formatDateTime,
  toUTCDateTimeString,
} from "../../../algorithms/date";
import { maxDate } from "../drop-off-status";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";

let colors = [
  "rgb(125, 215, 230)",
  "rgb(140, 195, 249)",
  "rgb(255, 182, 95)",
  "rgb(104, 186, 102)",
  "rgb(125, 215, 230)",
  "rgb(102, 33, 12)",
];

const LockerOccupancy = () => {
  ///TODO: add new line on the weekly view of every table | add \n on 4th string
  //variables
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const [lockerName, setLockerName] = useState([]);
  const [lockerType, setLockerType] = useState([]);

  const [isLoading, setisLoading] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState("weekly");
  const [chartData1, setchartData1] = useState([]);
  const [barsChartData2, setbarsChartData2] = useState([]);
  const [barChartValues, setbarChartValues] = useState([]);
  const [allLockersSelected, setAllLockersSelected] = useState(false);

  //   filtervariables
  const [filterVariables, setFilterVariables] = useState({
    lockerType: "-1",
    selectedLockerName: [],

    startDate: maxDate,
    endDate: new Date(),
    endTime: "23:59",
    startTime: "00:00",
  });
  //Setter Variable
  const [searchResultHeader, setSearchResultHeader] = useState("");
  const [summaryText, setsummaryText] = useState(<div></div>);
  const [summaryText2, setsummaryText2] = useState(<div></div>);
  const [selectedLockerName, setSelectedLockerName] = useState([]);
  const [selectedLockerType, setSelectedLockerType] = useState("-1");
  const [Table, setTable] = useState([]);
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  // const maxDate = (() => {
  //   const d = new Date();
  //   d.setMonth(d.getMonth() - 6);
  //   return d;
  // })();

  const [fetchStayTimeLockerName, { data: lockerNameData }] = useLazyQuery(
    NEWEST_LOCKER_NAME_QUERY,
    {
      variables: {
        operatorId: operatorId,
        // lockerTypeId: selectedLockerType,
      },
    }
  );
  const fetchAllLockers = useQuery(LOCKER_INFO_QUERY, {
    variables: { operatorId: operatorId },
  });
  const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);
  const [fetchAverage, { data, loading }] = useLazyQuery(
    QUERYlockerOccupancyAvgOccupancyRate,
    { fetchPolicy: "no-cache" }
  );
  const [fetchTable1, fetchTable1Data] = useLazyQuery(
    QUERYlockerOccupancyTable1,
    { fetchPolicy: "no-cache" }
  );
  const [fetchTable2, fetchTable2Data] = useLazyQuery(
    QUERYlockerOccupancyTable2,
    { fetchPolicy: "no-cache" }
  );
  const [fetchSummary, fetchSummaryData] = useLazyQuery(
    QUERYlockerOccupancyReportSummary,
    { fetchPolicy: "no-cache" }
  );

  //Fetch Average Occupancy Rate per Locker Table
  useEffect(() => {
    if (data) {
      let tempTable = [];
      data.lockerOccupancyAvgOccupancyRateByLocker.forEach((element, index) => {
        let obj = { ...element };
        var tempSize = [];
        var tempDoors = [];
        var tempPackages = [];
        var tempAvgOccD = [];
        var tempAvgTR = [];
        var tempAVGOccR = [];
        var totalTempPackages = 0;
        var totalTempAvgTR = 0;
        var totalTempDoors = 0;
        var totalTempAvgOccD = 0;
        var totalTempAVGOccR = 0;
        obj.doorSizes.forEach((k2, i2) => {
          tempSize.push(k2.size);
          tempDoors.push(k2.doors);
          tempPackages.push(k2.packages);
          tempAvgOccD.push(k2.avgOccupiedDoors);
          tempAvgTR.push(k2.avgTurnoverRate);
          tempAVGOccR.push(
            `${(parseFloat(k2.avgOccupancyRate) * 100).toFixed(1)}%`
          );
          totalTempPackages = totalTempPackages + k2.packages;
          totalTempAvgTR = totalTempAvgTR + k2.avgTurnoverRate;
          totalTempDoors = totalTempDoors + k2.doors;
          totalTempAvgOccD = totalTempAvgOccD + k2.avgOccupiedDoors;
          totalTempAVGOccR = totalTempAVGOccR + k2.avgOccupancyRate * 100;
        });
        obj.tempSize = tempSize;
        // obj.lockerStatus =
        obj.tempDoors = tempDoors;
        obj.tempPackages = tempPackages;
        obj.tempAvgOccD = tempAvgOccD;
        obj.tempAvgTR = tempAvgTR;
        obj.tempAVGOccR = tempAVGOccR;
        obj.totalTempPackages = totalTempPackages;
        obj.totalTempAvgTR = totalTempAvgTR;
        obj.totalTempDoors = totalTempDoors;
        obj.totalTempAvgOccD = totalTempAvgOccD;
        obj.totalTempAVGOccR = totalTempAVGOccR;
        tempTable.push(obj);
        tempTable.push({
          lockerName: "Total",
          tempPackages: [obj.totalTempPackages],
          tempAvgTR: [obj.totalTempAvgTR],
          tempDoors: [obj.totalTempDoors],
          tempAvgOccD: [obj.totalTempAvgOccD],
          tempAVGOccR: [
            `${(totalTempAVGOccR / obj.tempAVGOccR.length).toFixed(1)}%`,
          ],
        });
        // tempTable.push({
        //   lockerName: obj.lockerName, // keep group key for grouping
        //   lockerStatus: "Total", // move label here
        //   tempPackages: [totalTempPackages],
        //   tempAvgTR: [totalTempAvgTR],
        //   tempDoors: [totalTempDoors],
        //   tempAvgOccD: [totalTempAvgOccD],
        //   tempAVGOccR: [
        //     `${(totalTempAVGOccR / tempAVGOccR.length).toFixed(1)}%`,
        //   ],
        //   isTotalRow: true, // optional flag for styling
        // });
      });
      setTable(tempTable);
    }
  }, [data]);

  console.log({ Table });
  useEffect(() => {
    if (fetchTable1Data.data) {
      if (selectedRadio == "weekly") {
        let tempArr = [];
        fetchTable1Data.data.lockerOccupancyByDate.forEach((k, i) => {
          let obj = { ...k };
          obj.avgOccupancyRate = `${(obj.avgOccupancyRate * 100).toFixed(0)}`;
          // obj.date = obj.date + " year";
          tempArr.push(obj);
        });
        setchartData1(tempArr);
      } else {
        let tempArr = [];
        fetchTable1Data.data.lockerOccupancyByDate.forEach((k, i) => {
          let obj = { ...k };
          obj.avgOccupancyRate = `${(obj.avgOccupancyRate * 100).toFixed(0)}`;
          tempArr.push(obj);
        });
        setchartData1(tempArr);
      }
    }
  }, [fetchTable1Data.data]);

  const getPeakOccupancyDetails = (data) => {
    if (!data || data.length === 0) return { rate: 0, date: "" };

    let maxItem = data[0];
    data.forEach((item) => {
      if (
        parseFloat(item.avgOccupancyRate) > parseFloat(maxItem.avgOccupancyRate)
      ) {
        maxItem = item;
      }
    });

    return {
      rate: parseFloat(maxItem.avgOccupancyRate).toFixed(1),
      date: maxItem.date,
    };
  };

  useEffect(() => {
    if (fetchTable2Data.data) {
      let tempData = [];
      let tempPartners = [];
      fetchTable2Data.data.lockerOccupancyDoorSizeOccupancyByDate.forEach(
        (element, index) => {
          let tempArr = [];
          element.doorSizes.forEach((e, i) => {
            if (e.packages > 0) {
              tempArr.push({ [e.size]: e.packages });
              if (!tempPartners.includes(e.size)) {
                tempPartners.push(e.size);
              }
            }
          });
          tempArr.push({ date: element.date });
          const combinedObject = tempArr.reduce(
            (acc, obj) => ({ ...acc, ...obj }),
            {}
          );
          tempData.push(combinedObject);
        }
      );
      let tempBars = [];
      // setTempPartners1(tempPartners);
      tempPartners.forEach((e, i) => {
        tempBars.push(<Bar dataKey={e} fill={colors[i % 20]} label={e} />);
      });
      setbarsChartData2(tempBars);
      setbarChartValues(tempData);
      // console.log(tempData);
    }
  }, [fetchTable2Data.data]);

  const peakDetails = getPeakOccupancyDetails(chartData1);

  // Helper component for stat cards
  const StatCard = ({ title, value, subtitle, className = "" }) => (
    <div
      className={`bg-slate-50 space-y-2 p-2 border border-gray-300 rounded-lg text-center ${className}`}
    >
      <div className="text-base uppercase text-gray-600">{title}</div>
      <div className="font-bold uppercase text-3xl">{value}</div>
      <div className="text-base lowercase text-gray-600">{subtitle}</div>
    </div>
  );

  // Helper component for door size cards
  const DoorSizeCard = ({ data, color }) => (
    <div className="bg-slate-50 space-y-2 p-2 col-span-4 border border-gray-300 rounded-lg text-left">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div
            className="h-[25px] w-[25px] mr-4"
            style={{ backgroundColor: color }}
          />
          <div className="text-base uppercase text-gray-600">
            {data?.size ?? 0} door
          </div>
        </div>
        <Tag className="text-base uppercase text-secondary-purpleGray bg-primary-primaryYellowLight">
          {data?.packages ?? 0}{" "}
          <span className="lowercase font-normal">packages</span>
        </Tag>
      </div>
      <div className="font-bold uppercase text-3xl">
        {data?.utilizationRate ?? 0}%{" "}
        <span className="text-base lowercase font-normal">
          utilization rate
        </span>
      </div>
      <div className="text-base lowercase text-gray-600">
        {data?.doors ?? 0} of {data?.totalDoors ?? 0} doors used for this period
      </div>
    </div>
  );

  useEffect(() => {
    if (fetchSummaryData.data) {
      const summary = fetchSummaryData.data.lockerOccupancyReportSummary[0];
      const dateRange = `${formatDate(
        filterVariables.startDate
      )} - ${formatDate(filterVariables.endDate)}`;

      setsummaryText(
        <div className="grid grid-cols-12 font-montserrat text-secondary-purpleGray py-5 mx-6 rounded-lg">
          <div className="font-bold col-span-12 text-center mb-2 text-lg">
            Summary for the period of {dateRange}
          </div>
          <div className="col-span-12">
            <div className="grid grid-cols-8 space-x-2">
              <div className="col-span-1" />
              <StatCard
                className="col-span-2"
                title="Total Packages"
                value={summary.packages ?? 0}
                subtitle="in this period"
              />
              <StatCard
                className="col-span-2"
                title="Total Doors"
                value={summary.doors ?? 0}
                subtitle={`across ${summary.lockers ?? 0} active lockers`}
              />
              <StatCard
                className="col-span-2"
                title="Peak Occupancy"
                value={peakDetails.rate}
                subtitle={
                  <>
                    observed on{" "}
                    <span className="capitalize">{peakDetails.date}</span>
                  </>
                }
              />
              <div className="col-span-1" />
            </div>
          </div>
        </div>
      );

      setsummaryText2(
        <div className="grid grid-cols-12 font-montserrat text-secondary-purpleGray py-5 mx-6 rounded-lg">
          <div className="font-bold col-span-12 text-center mb-2 text-lg">
            Summary for the period of {dateRange}
          </div>
          <div className="col-span-12">
            <div className="grid grid-cols-12 gap-2 mx-3">
              {summary.doorSizes?.map((doorSize, idx) => (
                <DoorSizeCard key={idx} data={doorSize} color={colors[idx]} />
              ))}
              {/* <div className="bg-slate-50 space-y-2 p-2 border border-gray-300 rounded-lg text-left col-span-12 mx-12">
                dsfsdf
              </div> */}
            </div>
          </div>
        </div>
      );
    }
  }, [fetchSummaryData.data]);

  console.log({ DOORS: fetchSummaryData.data });
  //To fetch locker Type
  useEffect(() => {
    if (fetchLockerType.data) {
      let tempData = [];
      fetchLockerType.data.lockerTypes.forEach((element, index) =>
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        })
      );
      setLockerType(tempData);
    }
  }, [fetchLockerType.data]);

  //To Fetch LockerName
  useEffect(() => {
    if (filterVariables.lockerType !== "-1") {
      fetchStayTimeLockerName({
        variables: {
          operatorId: operatorId,
          lockerTypeId: filterVariables.lockerType,
        },
      });
    }
  }, [filterVariables.lockerType, operatorId]);

  useEffect(() => {
    if (lockerNameData) {
      const tempData = lockerNameData.lockerInfo.map((element) => ({
        label: element.lockerName,
        value: element.lockerId,
      }));

      if (!allLockersSelected) {
        tempData.unshift({
          value: 0,
          label: "All Lockers",
        });
      }

      setLockerName(tempData);
    }
  }, [lockerNameData, allLockersSelected]);

  useEffect(() => {
    const selected = filterVariables.selectedLockerName;
    const allLockers = lockerName;

    const hasZeroValue = selected.some((item) => item.value === 0);

    if (hasZeroValue) {
      setAllLockersSelected(true);
    } else if (selected.length === 0) {
      setAllLockersSelected(false);
    } else if (selected.length !== allLockers.length) {
      setAllLockersSelected(false);
    } else {
      setAllLockersSelected(true);
    }
  }, [filterVariables.selectedLockerName, lockerName]);

  useEffect(() => {
    if (allLockersSelected) {
      const selectedLockers = lockerName.filter((locker) => locker.value !== 0);

      setFilterVariables({
        ...filterVariables,
        selectedLockerName: selectedLockers,
      });
    }
  }, [allLockersSelected, lockerName]);

  // const formatDate = (date) => {
  //   if (!date) return "";
  //   const d = new Date(date);
  //   const year = d.getFullYear();
  //   const month = String(d.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month
  //   const day = String(d.getDate()).padStart(2, "0"); // Ensure two-digit day
  //   return `${year}-${month}-${day}`;
  // };

  const buildVariables = () => {
    const updatedVariables = {};
    const operatorId = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "";

    // always assign operatorid
    updatedVariables.operatorId = operatorId;

    // date splitting
    let startResults = toUTCDateTimeString(
      new Date(filterVariables.startDate),
      filterVariables.startTime || "00:00"
    );
    const [startDatePart, startTimePart] = startResults.split(" ");
    let endResults = toUTCDateTimeString(
      new Date(filterVariables.endDate),
      filterVariables.endTime || "00:00"
    );
    const [endDatePart, endTimePart] = endResults.split(" ");

    if (filterVariables.lockerType !== "-1") {
      updatedVariables.lockerTypeId = filterVariables.lockerType;
    }

    if (filterVariables.selectedLockerName.length !== 0) {
      const lockerIdValues = filterVariables.selectedLockerName.map(
        (locker) => locker.value
      );

      updatedVariables.lockers = lockerIdValues;
    }

    if (filterVariables.startDate) {
      updatedVariables.dateStart = startDatePart;
    }

    if (filterVariables.startTime) {
      updatedVariables.hourStart = startTimePart;
    }

    if (filterVariables.endDate) {
      updatedVariables.dateEnd = endDatePart;
    }

    if (filterVariables.endTime) {
      updatedVariables.hourEnd = endTimePart;
    }

    return updatedVariables;
  };

  const [isClicked, setIsClicked] = useState(false);

  const handleSearch = (e) => {
    initializeSearch();

    if (!validateSearchInputs()) {
      return;
    } else {
      executeSearch();
    }
  };

  // Initialize search state
  const initializeSearch = () => {
    setisLoading(true);
    setIsClicked(true);
    setchartData1([]);
    setbarChartValues([]);
  };

  // Validation functions
  const validateSearchInputs = () => {
    return (
      validateLockerSelection() && validateDateRange() && validateTimeRange()
    );
  };

  const validateLockerSelection = () => {
    if (
      filterVariables.selectedLockerName.length === 0 &&
      filterVariables.lockerType !== "-1"
    ) {
      showValidationError("Invalid Locker", "Please select a locker name.");
      return false;
    }
    return true;
  };

  const validateDateRange = () => {
    const start = new Date(filterVariables.startDate);
    const end = new Date(filterVariables.endDate);

    if (end < start) {
      showValidationError(
        "Invalid date range.",
        "End date cannot be before the start date."
      );
      return false;
    }
    return true;
  };

  const validateTimeRange = () => {
    if (filterVariables.startTime === "" || filterVariables.endTime === "") {
      showValidationError("Invalid Time", "No time range selected.");
      return false;
    }
    return true;
  };

  // Helper function to show validation errors
  const showValidationError = (title, message) => {
    setValidation({
      icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
      title,
      message,
      open: true,
      actions: (
        <div className="w-full">
          <Button
            onClick={() => setValidation({ open: false })}
            value={"OK"}
            className={"p-2 w-full"}
          />
        </div>
      ),
    });

    resetSearchState();
  };

  // Reset search state on validation failure
  const resetSearchState = () => {
    setIsClicked(false);
    setisLoading(false);
  };

  // Execute the actual search
  const executeSearch = () => {
    handleSearchResultHeader();
    const searchVariables = buildVariables();

    performDataFetching(searchVariables);
  };

  // Handle all data fetching operations
  const performDataFetching = (variables) => {
    const fetchPromises = [
      fetchAverage({ variables }),
      fetchTable1({ variables: { ...variables, period: selectedRadio } }),
      fetchTable2({ variables: { ...variables, period: selectedRadio } }),
      fetchSummary({ variables }),
    ];

    // Handle all fetch operations
    Promise.allSettled(fetchPromises)
      .then(handleFetchResults)
      .finally(() => {
        setisLoading(false);
      });
  };

  // Handle fetch results
  const handleFetchResults = (results) => {
    const failedFetches = results.filter(
      (result) => result.status === "rejected"
    );

    if (failedFetches.length > 0) {
      console.error("Some fetch operations failed:", failedFetches);
      // Handle failed fetches if needed
    }
  };
  const handleTabClick = (e) => {
    // setisLoading(true);
    const variable1 = buildVariables();
    setSelectedRadio(e);
    fetchTable1({
      variables: { ...variable1, period: e },
    }).catch((e) => {
      setisLoading(false);
    });
    fetchTable2({
      variables: { ...variable1, period: e },
    })
      .catch((e) => {
        setisLoading(false);
      })
      .then((e) => {
        setisLoading(false);
      });
  };

  function handleSearchResultHeader() {
    // Check if all lockers are selected
    let lockerNameText;
    if (allLockersSelected) {
      lockerNameText = "ALL Lockers";
    } else {
      const lockerLabels = filterVariables.selectedLockerName
        .map((selectedLocker) => {
          const matchedLocker = lockerName.find(
            (item) => parseInt(item.value) === parseInt(selectedLocker.value)
          );
          return matchedLocker ? matchedLocker.label : null;
        })
        .filter((label) => label !== null);

      lockerNameText =
        lockerLabels.length > 0 ? lockerLabels.join(", ") : "ALL Lockers";
    }

    setSearchResultHeader(`
        for ${lockerNameText},
        ${formatDate(filterVariables.startDate)} to ${formatDate(
      filterVariables.endDate
    )} from ${tConvert(filterVariables.startTime)} to ${tConvert(
      filterVariables.endTime
    )}
    `);
  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload[0]) {
      return (
        <div className="bg-white rounded-md border border-gray-600 px-2 py-4">
          <p className="text-bold text-center text-xl">{`${label}`}</p>
          <p className="text-normal">{`Average Occupancy Rate: ${payload[0].value}%`}</p>
        </div>
      );
    }

    return null;
  };

  const CustomTooltip2 = ({ active, payload, label }) => {
    if (active && payload[0]) {
      const total = payload.reduce((sum, entry) => sum + entry.value, 0);
      return (
        <div className={"bg-white rounded-md border border-gray-600"}>
          <div className="p-2">
            <p>{`${label}`}</p>
            {payload.map((entry, index) => (
              <p key={index} style={{ color: entry.color }}>
                {`${entry.name}: ${entry.value}`}
              </p>
            ))}
            <p>Total Packages: {total}</p>
          </div>
        </div>
      );
    }

    return null;
  };

  const bothTabComponent = (
    <TabComponent2
      index2={selectedRadio}
      tabs={[
        {
          value: "daily",
          title: "Daily",
        },
        {
          value: "weekly",
          title: "Weekly",
        },
        {
          value: "weekday",
          title: "Day of the Week",
        },
        {
          value: "monthly",
          title: "Monthly",
        },
        {
          value: "yearly",
          title: "Yearly",
        },
      ]}
      onTabClick={handleTabClick}
    />
  );

  function tConvert(time) {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? " AM" : " PM";
      time[0] = +time[0] % 12 || 12;
    }
    return time.join("");
  }

  useEffect(() => {
    if (allLockersSelected) {
      const selectedLockers =
        lockerName?.filter((locker) => locker.value !== 0) || [];

      setSelectedLockerName(selectedLockers);
    }
  }, [allLockersSelected, lockerName]);

  // handle change filter variables
  const handleFilterChange = (e, field) => {
    setIsClicked(false);
    let value = e.target.value;

    if (field === "startDate" || field === "endDate") {
      value = value ? new Date(value) : null;
    }
    if (field === "lockerType") {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
        selectedLockerName: [],
      });
    } else {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
      });
    }
  };

  const getYAxisConfig = (data) => {
    const maxValue = Math.max(...data.map((d) => d.avgOccupancyRate || 0));
    const ceiling = Math.ceil(maxValue * 1.15);
    const roundedMax = Math.ceil(ceiling / 5) * 5;

    // Generate ticks (every 5%)
    const ticks = [];
    for (let i = 0; i <= roundedMax; i += 5) {
      ticks.push(i);
    }

    return { domain: [0, roundedMax], ticks };
  };

  // Then in your component:
  const yAxisConfig = getYAxisConfig(chartData1);

  return (
    <div>
      <ContentContainer containerTitle="Locker Occupancy Report">
        <div>
          <h2 className={"font-bold"}>Locker:</h2>
          <div>
            <div
              className={"grid grid-cols-11 items-center w-full gap-y-2 pb-2"}
            >
              <p className="col-span-2">Locker Type:</p>
              <Select
                items={lockerType}
                className={`col-span-7`}
                value={filterVariables.lockerType}
                defaultOption={{ value: "-1", name: "-- ALL --" }}
                onChange={(event) => {
                  // setAllLockersSelected(false);
                  setFilterVariables({
                    ...filterVariables,
                    selectedLockerName: [],
                  });

                  handleFilterChange(event, "lockerType");
                }}
              />
            </div>

            <div
              className={"grid grid-cols-11 items-center w-full gap-y-2 pb-2"}
            >
              <p className="col-span-2">Locker Name:</p>

              <MultiSelect
                items={lockerName}
                // defaultOption={{ value: "-1", name: "-- ALL --" }}
                value={filterVariables.selectedLockerName}
                placeholder={`${
                  filterVariables.lockerType === "-1"
                    ? "ALL Lockers"
                    : "Select..."
                }`}
                disabled={filterVariables.lockerType === "-1"}
                className={`col-span-7`}
                onChange={(event) => {
                  handleFilterChange(event, "selectedLockerName");
                }}
              />
            </div>
          </div>
          <h1 className={"font-bold pb-2"}>Date range:</h1>

          <PrimereactDateRange
            className={"w-1/2"}
            startDate={filterVariables.startDate}
            endDate={filterVariables.endDate}
            startTime={filterVariables.startTime}
            endTime={filterVariables.endTime}
            max={new Date()} // Today's date as the maximum
            min={new Date("2021-01-01")} // Jan 1, 2021, as the minimum
            startDateName="startDate"
            endDateName="endDate"
            startTimeName="startTime"
            endTimeName="endTime"
            timeOnly={true}
            readOnlyInput={true}
            // yearRange="2001:2021"
            onChange={(event, fieldName) => {
              handleFilterChange(event, fieldName);
            }}
          />

          {/* <h1 className={"font-bold pt-2"}>Time range:</h1>
          <DateRangePicker
            dType="time"
            className={"w-1/2"}
            startDate={startTime}
            endDate={endTime}
            onChange={(event) => {
              if (event.target.name === "signupDateFrom") {
                setstartTime(event.target.value);
              } else {
                setendTime(event.target.value);
              }
            }}
          /> */}
          <div className="grid grid-cols-2 w-1/2 gap-y-2">
            <div></div>
            <u
              className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
              onClick={() => {
                setFilterVariables({
                  ...filterVariables,
                  startDate: maxDate,
                  endDate: new Date(),
                  selectedLockerName: [],
                  lockerType: "-1",
                  endTime: "23:59",
                  startTime: "00:00",
                });
                setIsClicked(false);
              }}
            >
              <i className="fas fa-undo my-auto"></i>
              <p className="ml-1">Reset</p>
            </u>
          </div>
          <Button
            value={"Search"}
            className={"w-40 h-8 mb-2 mt-4"}
            onClick={handleSearch}
          />

          {isClicked &&
            (isLoading ? (
              <LoadingComponent />
            ) : (
              <>
                <Accordion multiple={true} activeIndex={[0, 1, 2]}>
                  {/* Locker Occupancy Report Accordion Tab */}
                  <AccordionTab header="Locker Occupancy Report">
                    {chartData1.length > 0 && (
                      <>
                        <div className="flex items-center justify-end gap-2 bg-yellow-400 pr-4 py-1">
                          <DownloadButton
                            pngOnly={true}
                            id={"Locker Occupancy Report"}
                          />
                        </div>
                        <div
                          className={"border border-black"}
                          id="Locker Occupancy Report"
                        >
                          <div className={"grid grid-row-2 bg-yellow-400 p-1 "}>
                            <div>{bothTabComponent}</div>
                            <div className={"text-center"}>
                              <h1 className={"font-bold"}>
                                Locker Occupancy Report
                              </h1>
                              <h1 className={"font-bold"}>
                                {searchResultHeader}
                              </h1>
                            </div>
                          </div>
                          {summaryText}

                          {/* already fixed the barchart here */}
                          <ResponsiveContainer
                            width={"100%"}
                            height={500}
                            className={`pt-5`}
                          >
                            <BarChart
                              data={chartData1}
                              margin={{
                                top: 10,
                                right: 10,
                                left: 20,
                                bottom: 10,
                              }}
                            >
                              <CartesianGrid
                                stroke="#999"
                                strokeDasharray="3 3"
                                opacity={0.7}
                              />

                              <XAxis dataKey="date" />
                              <YAxis
                                tickFormatter={(value) => `${value}%`}
                                // domain={[0, 20]}
                                // ticks={[0, 5, 10, 15, 20]}
                                domain={yAxisConfig.domain}
                                ticks={yAxisConfig.ticks}
                              >
                                <Label
                                  value={"Average Occupancy Rate"}
                                  angle={-90}
                                  position={"left"}
                                />
                              </YAxis>
                              <Tooltip content={CustomTooltip} />
                              <Bar
                                dataKey={"avgOccupancyRate"}
                                fill={colors[2]}
                              />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </>
                    )}
                  </AccordionTab>

                  {/* Average Occupancy Rate per Locker Accordion Tab */}
                  <AccordionTab header="Average Occupancy Rate per Locker">
                    {Table.length > 0 && (
                      <>
                        <DownloadButton
                          pngOnly={true}
                          id={"Average Occupancy Rate per Locker"}
                        />
                        <div
                          className="bg-primary-primaryYellow  border-2 border-yellow-400 mb-8"
                          id="Average Occupancy Rate per Locker"
                        >
                          <div className={"text-center"}>
                            <h1 className={"font-bold"}>
                              Average Occupancy Rate per Locker
                            </h1>
                            <span className="text-xs ">
                              includes inactive lockers
                            </span>
                            <h1 className={"font-bold pt-4"}>
                              {searchResultHeader}
                            </h1>
                          </div>
                          <GroupedTable2
                            groupBy={{
                              header_name: "Locker Name",
                              key: "lockerName",
                            }}
                            groupBy2={{
                              header_name: "Locker Status",
                              key: "lockerStatus",
                            }}
                            multiData={[
                              "tempSize",
                              "tempDoors",
                              "tempPackages",
                              "tempAvgOccD",
                              "tempAvgTR",
                              "tempAVGOccR",
                            ]}
                            headers={[
                              { header_name: "Locker Name", key: "lockerName" },
                              {
                                header_name: "Locker Status",
                                key: "lockerStatus",
                              },
                              { header_name: "Door Size", key: "tempSize" },
                              {
                                header_name: "Total Packages",
                                key: "tempPackages",
                              },
                              {
                                header_name: "Avg Turnover Rate",
                                key: "tempAvgTR",
                              },
                              { header_name: "Total Doors", key: "tempDoors" },
                              {
                                header_name: "Average Occupied Doors",
                                key: "tempAvgOccD",
                              },
                              {
                                header_name: "Avg Occupancy Rate",
                                key: "tempAVGOccR",
                              },
                            ]}
                            items={Table}
                          />
                        </div>
                      </>
                    )}
                  </AccordionTab>

                  {/* Door Size Occupancy Report Accordion Tab */}
                  <AccordionTab header="Door Size Occupancy Report">
                    {barChartValues.length > 0 && (
                      <>
                        <div className="flex items-center justify-end gap-2 bg-yellow-400 pr-4 py-1">
                          <DownloadButton
                            pngOnly={true}
                            id={"Door Size Occupancy Report"}
                          />
                        </div>
                        <div
                          className={"border border-black"}
                          id="Door Size Occupancy Report"
                        >
                          <div className={"grid grid-row-2 bg-yellow-400 p-2 "}>
                            <div>{bothTabComponent}</div>
                            <div className={"text-center"}>
                              <h1 className={"font-bold"}>
                                Door Size Occupancy Report
                              </h1>
                              <h1 className={"font-bold"}>
                                {searchResultHeader}
                              </h1>
                            </div>
                          </div>
                          {summaryText2}
                          <ResponsiveContainer width={"100%"} height={500}>
                            <BarChart
                              data={barChartValues}
                              margin={{
                                top: 10,
                                right: 10,
                                left: 20,
                                bottom: 10,
                              }}
                            >
                              <CartesianGrid
                                stroke="#999"
                                strokeDasharray="3 3"
                                opacity={0.7}
                              />

                              <XAxis dataKey="date" />
                              <YAxis>
                                <Label
                                  value={"Packages"}
                                  angle={-90}
                                  position={"left"}
                                  tickFormatter={(value) => `${value}%`}
                                  // domain={[0, 20]}
                                  // ticks={[0, 5, 10, 15, 20]}
                                  domain={yAxisConfig.domain}
                                  ticks={yAxisConfig.ticks}
                                />
                              </YAxis>
                              <Tooltip content={CustomTooltip2} />
                              {barsChartData2}
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </>
                    )}
                  </AccordionTab>
                </Accordion>
              </>
            ))}

          <div className="w-full h-[40px]"></div>
        </div>
        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />
      </ContentContainer>

      {/* <ScrollButton /> */}
    </div>
  );
};

export default LockerOccupancy;

// function formatDate(inputDate) {
//   if (inputDate == null) {
//     return "";
//   }
//   const date = new Date(inputDate);
//   const options = {
//     year: "numeric",
//     month: "short",
//     day: "numeric",
//   };
//   return date.toLocaleDateString(undefined, options);
// }
